import AccordionCustomComponent from "components/common/layouts/Accordion";
import { CopyButton } from "components/common/ui/Buttons/Copy-Button";
import { useSelector } from "react-redux";
export function BusinessCalendar() {
  const uid = useSelector((state: any) => state.firebase.auth.uid);
  const link = `https://parks.touritickets.de/iFrames/calendar/${uid}`;
  return <AccordionCustomComponent title={"Business Calendar"}>
			<CopyButton value={link} />
		</AccordionCustomComponent>;
}